export enum EXPORT_LIST_TABLE_COLUMNS {
    NAME = 'name',
    CREATED_AT = 'created_at',
    UPDATED_AT = 'updated_at',
    ACTIONS = 'actions'
}
export const EXPORT_LIST_TABLE_HEADER = [
    EXPORT_LIST_TABLE_COLUMNS.NAME,
    EXPORT_LIST_TABLE_COLUMNS.CREATED_AT,
    EXPORT_LIST_TABLE_COLUMNS.UPDATED_AT,
    EXPORT_LIST_TABLE_COLUMNS.ACTIONS
];

export const EXPORT_LIST_DEFAULT_SORT_COLUMN = EXPORT_LIST_TABLE_COLUMNS.CREATED_AT;
export const EXPORT_LIST_DEFAULT_SORT_COLUMN_DIRECTION = 'desc';
export const EXPORT_LIST_PAGE_SIZE_OPTIONS = [5, 10];
export const EXPORT_LIST_PAGE_DEFAULT_SIZE = 5;
